<template>
  <svg
    width="96"
    height="84"
    viewBox="0 0 96 84"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M34.6274 28.4492C34.6274 21.0635 40.6147 15.0762 48.0004 15.0762C55.3861 15.0762 61.3734 21.0635 61.3734 28.4491V52.7271H34.6274V28.4492ZM48.0004 21.0762C43.9284 21.0762 40.6274 24.3772 40.6274 28.4492V46.7271H55.3734V28.4491C55.3734 24.3772 52.0724 21.0762 48.0004 21.0762Z"
      fill="#754A47"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M34.6274 28.4492C34.6274 21.0635 40.6147 15.0762 48.0004 15.0762C55.3861 15.0762 61.3734 21.0635 61.3734 28.4491V52.7271H34.6274V28.4492ZM48.0004 21.0762C43.9284 21.0762 40.6274 24.3772 40.6274 28.4492V46.7271H55.3734V28.4491C55.3734 24.3772 52.0724 21.0762 48.0004 21.0762Z"
      fill="url(#paint0_radial_13_481)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M34.6274 28.4492C34.6274 21.0635 40.6147 15.0762 48.0004 15.0762C55.3861 15.0762 61.3734 21.0635 61.3734 28.4491V52.7271H34.6274V28.4492ZM48.0004 21.0762C43.9284 21.0762 40.6274 24.3772 40.6274 28.4492V46.7271H55.3734V28.4491C55.3734 24.3772 52.0724 21.0762 48.0004 21.0762Z"
      fill="url(#paint1_radial_13_481)"
      fill-opacity="0.87"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M34.6274 28.4492C34.6274 21.0635 40.6147 15.0762 48.0004 15.0762C55.3861 15.0762 61.3734 21.0635 61.3734 28.4491V52.7271H34.6274V28.4492ZM48.0004 21.0762C43.9284 21.0762 40.6274 24.3772 40.6274 28.4492V46.7271H55.3734V28.4491C55.3734 24.3772 52.0724 21.0762 48.0004 21.0762Z"
      fill="url(#paint2_radial_13_481)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M34.6274 28.4492C34.6274 21.0635 40.6147 15.0762 48.0004 15.0762C55.3861 15.0762 61.3734 21.0635 61.3734 28.4491V52.7271H34.6274V28.4492ZM48.0004 21.0762C43.9284 21.0762 40.6274 24.3772 40.6274 28.4492V46.7271H55.3734V28.4491C55.3734 24.3772 52.0724 21.0762 48.0004 21.0762Z"
      fill="url(#paint3_radial_13_481)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M34.6274 28.4492C34.6274 21.0635 40.6147 15.0762 48.0004 15.0762C55.3861 15.0762 61.3734 21.0635 61.3734 28.4491V52.7271H34.6274V28.4492ZM48.0004 21.0762C43.9284 21.0762 40.6274 24.3772 40.6274 28.4492V46.7271H55.3734V28.4491C55.3734 24.3772 52.0724 21.0762 48.0004 21.0762Z"
      fill="url(#paint4_radial_13_481)"
      fill-opacity="0.6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M34.6274 28.4492C34.6274 21.0635 40.6147 15.0762 48.0004 15.0762C55.3861 15.0762 61.3734 21.0635 61.3734 28.4491V52.7271H34.6274V28.4492ZM48.0004 21.0762C43.9284 21.0762 40.6274 24.3772 40.6274 28.4492V46.7271H55.3734V28.4491C55.3734 24.3772 52.0724 21.0762 48.0004 21.0762Z"
      fill="url(#paint5_radial_13_481)"
      fill-opacity="0.72"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M34.6274 28.4492C34.6274 21.0635 40.6147 15.0762 48.0004 15.0762C55.3861 15.0762 61.3734 21.0635 61.3734 28.4491V52.7271H34.6274V28.4492ZM48.0004 21.0762C43.9284 21.0762 40.6274 24.3772 40.6274 28.4492V46.7271H55.3734V28.4491C55.3734 24.3772 52.0724 21.0762 48.0004 21.0762Z"
      fill="url(#paint6_radial_13_481)"
    />
    <path
      d="M6.15381 42.1626C6.15381 38.8489 8.8401 36.1626 12.1538 36.1626H83.847C87.1607 36.1626 89.847 38.8489 89.847 42.1626V83.8893C89.847 87.203 87.1607 89.8893 83.847 89.8893H12.1538C8.84011 89.8893 6.15381 87.203 6.15381 83.8893V42.1626Z"
      fill="url(#paint7_linear_13_481)"
    />
    <path
      d="M6.15381 42.1626C6.15381 38.8489 8.8401 36.1626 12.1538 36.1626H83.847C87.1607 36.1626 89.847 38.8489 89.847 42.1626V83.8893C89.847 87.203 87.1607 89.8893 83.847 89.8893H12.1538C8.84011 89.8893 6.15381 87.203 6.15381 83.8893V42.1626Z"
      fill="url(#paint8_linear_13_481)"
    />
    <path
      d="M6.15381 42.1626C6.15381 38.8489 8.8401 36.1626 12.1538 36.1626H83.847C87.1607 36.1626 89.847 38.8489 89.847 42.1626V83.8893C89.847 87.203 87.1607 89.8893 83.847 89.8893H12.1538C8.84011 89.8893 6.15381 87.203 6.15381 83.8893V42.1626Z"
      fill="url(#paint9_radial_13_481)"
    />
    <path
      d="M6.15381 42.1626C6.15381 38.8489 8.8401 36.1626 12.1538 36.1626H83.847C87.1607 36.1626 89.847 38.8489 89.847 42.1626V83.8893C89.847 87.203 87.1607 89.8893 83.847 89.8893H12.1538C8.84011 89.8893 6.15381 87.203 6.15381 83.8893V42.1626Z"
      fill="url(#paint10_radial_13_481)"
    />
    <path
      d="M6.15381 42.1626C6.15381 38.8489 8.8401 36.1626 12.1538 36.1626H83.847C87.1607 36.1626 89.847 38.8489 89.847 42.1626V83.8893C89.847 87.203 87.1607 89.8893 83.847 89.8893H12.1538C8.84011 89.8893 6.15381 87.203 6.15381 83.8893V42.1626Z"
      fill="url(#paint11_linear_13_481)"
    />
    <path
      d="M6.15381 42.1626C6.15381 38.8489 8.8401 36.1626 12.1538 36.1626H83.847C87.1607 36.1626 89.847 38.8489 89.847 42.1626V83.8893C89.847 87.203 87.1607 89.8893 83.847 89.8893H12.1538C8.84011 89.8893 6.15381 87.203 6.15381 83.8893V42.1626Z"
      fill="url(#paint12_linear_13_481)"
    />
    <path
      d="M6.15381 42.1626C6.15381 38.8489 8.8401 36.1626 12.1538 36.1626H83.847C87.1607 36.1626 89.847 38.8489 89.847 42.1626V83.8893C89.847 87.203 87.1607 89.8893 83.847 89.8893H12.1538C8.84011 89.8893 6.15381 87.203 6.15381 83.8893V42.1626Z"
      fill="url(#paint13_linear_13_481)"
    />
    <path
      d="M6.15381 42.1626C6.15381 38.8489 8.8401 36.1626 12.1538 36.1626H83.847C87.1607 36.1626 89.847 38.8489 89.847 42.1626V83.8893C89.847 87.203 87.1607 89.8893 83.847 89.8893H12.1538C8.84011 89.8893 6.15381 87.203 6.15381 83.8893V42.1626Z"
      fill="url(#paint14_linear_13_481)"
    />
    <path
      d="M6.15381 42.1626C6.15381 38.8489 8.8401 36.1626 12.1538 36.1626H83.847C87.1607 36.1626 89.847 38.8489 89.847 42.1626V83.8893C89.847 87.203 87.1607 89.8893 83.847 89.8893H12.1538C8.84011 89.8893 6.15381 87.203 6.15381 83.8893V42.1626Z"
      fill="url(#paint15_linear_13_481)"
    />
    <path
      d="M6.15381 42.1626C6.15381 38.8489 8.8401 36.1626 12.1538 36.1626H83.847C87.1607 36.1626 89.847 38.8489 89.847 42.1626V83.8893C89.847 87.203 87.1607 89.8893 83.847 89.8893H12.1538C8.84011 89.8893 6.15381 87.203 6.15381 83.8893V42.1626Z"
      fill="url(#paint16_linear_13_481)"
    />
    <path
      d="M6.15381 42.1626C6.15381 38.8489 8.8401 36.1626 12.1538 36.1626H83.847C87.1607 36.1626 89.847 38.8489 89.847 42.1626V83.8893C89.847 87.203 87.1607 89.8893 83.847 89.8893H12.1538C8.84011 89.8893 6.15381 87.203 6.15381 83.8893V42.1626Z"
      fill="url(#paint17_linear_13_481)"
    />
    <path
      d="M6.15381 42.1626C6.15381 38.8489 8.8401 36.1626 12.1538 36.1626H83.847C87.1607 36.1626 89.847 38.8489 89.847 42.1626V83.8893C89.847 87.203 87.1607 89.8893 83.847 89.8893H12.1538C8.84011 89.8893 6.15381 87.203 6.15381 83.8893V42.1626Z"
      fill="url(#paint18_linear_13_481)"
    />
    <path
      d="M6.15381 42.1626C6.15381 38.8489 8.8401 36.1626 12.1538 36.1626H83.847C87.1607 36.1626 89.847 38.8489 89.847 42.1626V83.8893C89.847 87.203 87.1607 89.8893 83.847 89.8893H12.1538C8.84011 89.8893 6.15381 87.203 6.15381 83.8893V42.1626Z"
      fill="url(#paint19_radial_13_481)"
    />
    <path
      d="M6.15381 42.1626C6.15381 38.8489 8.8401 36.1626 12.1538 36.1626H83.847C87.1607 36.1626 89.847 38.8489 89.847 42.1626V83.8893C89.847 87.203 87.1607 89.8893 83.847 89.8893H12.1538C8.84011 89.8893 6.15381 87.203 6.15381 83.8893V42.1626Z"
      fill="url(#paint20_radial_13_481)"
    />
    <path
      d="M6.15381 42.1626C6.15381 38.8489 8.8401 36.1626 12.1538 36.1626H83.847C87.1607 36.1626 89.847 38.8489 89.847 42.1626V83.8893C89.847 87.203 87.1607 89.8893 83.847 89.8893H12.1538C8.84011 89.8893 6.15381 87.203 6.15381 83.8893V42.1626Z"
      fill="url(#paint21_radial_13_481)"
    />
    <path
      d="M6.15381 33.0308C6.15381 29.7171 8.8401 27.0308 12.1538 27.0308H83.847C87.1607 27.0308 89.847 29.7171 89.847 33.0308V46.4085C89.847 52.2075 85.146 56.9085 79.347 56.9085H16.6538C10.8548 56.9085 6.15381 52.2075 6.15381 46.4085V33.0308Z"
      fill="url(#paint22_linear_13_481)"
    />
    <path
      d="M6.15381 33.0308C6.15381 29.7171 8.8401 27.0308 12.1538 27.0308H83.847C87.1607 27.0308 89.847 29.7171 89.847 33.0308V46.4085C89.847 52.2075 85.146 56.9085 79.347 56.9085H16.6538C10.8548 56.9085 6.15381 52.2075 6.15381 46.4085V33.0308Z"
      fill="url(#paint23_linear_13_481)"
    />
    <path
      d="M6.15381 33.0308C6.15381 29.7171 8.8401 27.0308 12.1538 27.0308H83.847C87.1607 27.0308 89.847 29.7171 89.847 33.0308V46.4085C89.847 52.2075 85.146 56.9085 79.347 56.9085H16.6538C10.8548 56.9085 6.15381 52.2075 6.15381 46.4085V33.0308Z"
      fill="url(#paint24_linear_13_481)"
    />
    <path
      d="M6.15381 33.0308C6.15381 29.7171 8.8401 27.0308 12.1538 27.0308H83.847C87.1607 27.0308 89.847 29.7171 89.847 33.0308V46.4085C89.847 52.2075 85.146 56.9085 79.347 56.9085H16.6538C10.8548 56.9085 6.15381 52.2075 6.15381 46.4085V33.0308Z"
      fill="url(#paint25_linear_13_481)"
    />
    <path
      d="M6.15381 33.0308C6.15381 29.7171 8.8401 27.0308 12.1538 27.0308H83.847C87.1607 27.0308 89.847 29.7171 89.847 33.0308V46.4085C89.847 52.2075 85.146 56.9085 79.347 56.9085H16.6538C10.8548 56.9085 6.15381 52.2075 6.15381 46.4085V33.0308Z"
      fill="url(#paint26_linear_13_481)"
    />
    <path
      d="M6.15381 33.0308C6.15381 29.7171 8.8401 27.0308 12.1538 27.0308H83.847C87.1607 27.0308 89.847 29.7171 89.847 33.0308V46.4085C89.847 52.2075 85.146 56.9085 79.347 56.9085H16.6538C10.8548 56.9085 6.15381 52.2075 6.15381 46.4085V33.0308Z"
      fill="url(#paint27_radial_13_481)"
    />
    <rect
      x="38.2471"
      y="51.1458"
      width="19.5047"
      height="14.7172"
      rx="1"
      fill="url(#paint28_linear_13_481)"
    />
    <rect
      x="38.2471"
      y="51.1458"
      width="19.5047"
      height="14.7172"
      rx="1"
      fill="url(#paint29_linear_13_481)"
    />
    <rect
      x="38.2471"
      y="51.1458"
      width="19.5047"
      height="14.7172"
      rx="1"
      fill="url(#paint30_linear_13_481)"
    />
    <rect
      x="38.2471"
      y="51.1458"
      width="19.5047"
      height="14.7172"
      rx="1"
      fill="url(#paint31_radial_13_481)"
    />
    <rect
      x="38.2471"
      y="51.1458"
      width="19.5047"
      height="14.7172"
      rx="1"
      fill="url(#paint32_radial_13_481)"
    />
    <rect
      x="38.2471"
      y="51.1458"
      width="19.5047"
      height="14.7172"
      rx="1"
      fill="url(#paint33_linear_13_481)"
    />
    <rect
      x="38.2471"
      y="51.1458"
      width="19.5047"
      height="14.7172"
      rx="1"
      fill="url(#paint34_radial_13_481)"
    />
    <rect
      x="38.2471"
      y="51.1458"
      width="19.5047"
      height="14.7172"
      rx="1"
      fill="url(#paint35_linear_13_481)"
    />
    <rect
      x="38.2471"
      y="51.1458"
      width="19.5047"
      height="14.7172"
      rx="1"
      fill="url(#paint36_linear_13_481)"
    />
    <path
      d="M57.7518 56.9086H38.2471V54.1458C38.2471 52.4889 39.5901 51.1458 41.2471 51.1458H54.7518C56.4086 51.1458 57.7518 52.4889 57.7518 54.1458V56.9086Z"
      fill="url(#paint37_linear_13_481)"
    />
    <path
      d="M57.7518 56.9086H38.2471V54.1458C38.2471 52.4889 39.5901 51.1458 41.2471 51.1458H54.7518C56.4086 51.1458 57.7518 52.4889 57.7518 54.1458V56.9086Z"
      fill="url(#paint38_linear_13_481)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_13_481"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(48.9115 27.9178) rotate(101.293) scale(9.78502 7.93703)"
      >
        <stop
          offset="0.645833"
          stop-color="#77425B"
        />
        <stop
          offset="1"
          stop-color="#774256"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint1_radial_13_481"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(48.9115 27.9178) rotate(101.293) scale(9.78502 7.93703)"
      >
        <stop
          offset="0.546875"
          stop-color="#603C3A"
        />
        <stop
          offset="1"
          stop-color="#603C3A"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint2_radial_13_481"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(32.3228 22.7656) rotate(107.475) scale(7.89212 5.05785)"
      >
        <stop
          offset="0.333333"
          stop-color="#77425C"
        />
        <stop
          offset="1"
          stop-color="#774256"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint3_radial_13_481"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(32.3228 22.7656) rotate(107.475) scale(7.89212 5.05785)"
      >
        <stop
          offset="0.333333"
          stop-color="#603C3A"
        />
        <stop
          offset="1"
          stop-color="#603C3A"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint4_radial_13_481"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(54.2481 19.3829) rotate(124.287) scale(1.71537 3.51657)"
      >
        <stop stop-color="#98726F" />
        <stop
          offset="1"
          stop-color="#98726F"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint5_radial_13_481"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(57.7269 22.9261) rotate(135) scale(2.09545 5.72128)"
      >
        <stop stop-color="#98726F" />
        <stop
          offset="1"
          stop-color="#98726F"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint6_radial_13_481"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(40.6551 22.3463) rotate(-148.57) scale(1.35898 5.57641)"
      >
        <stop stop-color="#7D5952" />
        <stop
          offset="1"
          stop-color="#7D5952"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint7_linear_13_481"
        x1="48.0004"
        y1="59.2502"
        x2="48.0004"
        y2="89.0027"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#81505E" />
        <stop
          offset="1"
          stop-color="#754759"
        />
      </linearGradient>
      <linearGradient
        id="paint8_linear_13_481"
        x1="48.0004"
        y1="56.2567"
        x2="48.0004"
        y2="58.331"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.151099"
          stop-color="#74394F"
        />
        <stop
          offset="1"
          stop-color="#74394F"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint9_radial_13_481"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(5.54707 60.7922) rotate(-7.96175) scale(10.1769)"
      >
        <stop
          offset="0.490139"
          stop-color="#81515F"
        />
        <stop
          offset="1"
          stop-color="#81515F"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint10_radial_13_481"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(91.2247 58.5021) rotate(177.013) scale(7.79729)"
      >
        <stop
          offset="0.490139"
          stop-color="#81515F"
        />
        <stop
          offset="1"
          stop-color="#81515F"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint11_linear_13_481"
        x1="48.0004"
        y1="90.2861"
        x2="48.0004"
        y2="88.0503"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#722E6C" />
        <stop
          offset="1"
          stop-color="#722E6C"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint12_linear_13_481"
        x1="87.231"
        y1="91.8541"
        x2="84.5345"
        y2="88.6298"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#722E60" />
        <stop
          offset="1"
          stop-color="#722E6C"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint13_linear_13_481"
        x1="91.3033"
        y1="75.0784"
        x2="89.0186"
        y2="75.0784"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#722E60" />
        <stop
          offset="1"
          stop-color="#722E6C"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint14_linear_13_481"
        x1="89.8469"
        y1="69.6059"
        x2="88.0419"
        y2="69.6059"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#946869" />
        <stop
          offset="1"
          stop-color="#946869"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint15_linear_13_481"
        x1="89.4081"
        y1="87.795"
        x2="87.496"
        y2="86.2463"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#946869" />
        <stop
          offset="1"
          stop-color="#946869"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint16_linear_13_481"
        x1="6.15381"
        y1="68.3622"
        x2="8.11728"
        y2="68.3622"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#693A47" />
        <stop
          offset="1"
          stop-color="#693A47"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint17_linear_13_481"
        x1="7.47656"
        y1="88.6877"
        x2="8.51953"
        y2="86.6369"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#693A3D" />
        <stop
          offset="1"
          stop-color="#693A47"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint18_linear_13_481"
        x1="47.2332"
        y1="89.8894"
        x2="47.2332"
        y2="88.4015"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#693A3D" />
        <stop
          offset="1"
          stop-color="#693A47"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint19_radial_13_481"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(40.4852 63.5768) rotate(88.3153) scale(4.00837)"
      >
        <stop
          offset="0.385489"
          stop-color="#70344D"
        />
        <stop
          offset="1"
          stop-color="#70344D"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint20_radial_13_481"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(47.3595 63.9076) rotate(80.0569) scale(3.71163 8.00072)"
      >
        <stop
          offset="0.4875"
          stop-color="#70344D"
        />
        <stop
          offset="1"
          stop-color="#70344D"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint21_radial_13_481"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(39.2914 59.0692) rotate(1.4688) scale(2.9031 6.25786)"
      >
        <stop
          offset="0.4875"
          stop-color="#70344D"
          stop-opacity="0.73"
        />
        <stop
          offset="1"
          stop-color="#70344D"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint22_linear_13_481"
        x1="48.0004"
        y1="27.0308"
        x2="48.0004"
        y2="56.9085"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#82525B" />
        <stop
          offset="1"
          stop-color="#714654"
        />
      </linearGradient>
      <linearGradient
        id="paint23_linear_13_481"
        x1="48.0004"
        y1="56.9084"
        x2="48.0004"
        y2="53.7465"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#632752" />
        <stop
          offset="0.667599"
          stop-color="#632752"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint24_linear_13_481"
        x1="85.281"
        y1="56.4886"
        x2="82.8397"
        y2="53.9037"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#632752" />
        <stop
          offset="1"
          stop-color="#632752"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint25_linear_13_481"
        x1="9.16982"
        y1="54.8371"
        x2="11.1085"
        y2="52.1804"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#632752" />
        <stop
          offset="1"
          stop-color="#632752"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint26_linear_13_481"
        x1="86.4194"
        y1="55.161"
        x2="84.7912"
        y2="52.8567"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6A315C" />
        <stop
          offset="1"
          stop-color="#6A315C"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint27_radial_13_481"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(40.9773 55.8018) rotate(-40.3645) scale(5.18747)"
      >
        <stop
          offset="0.4875"
          stop-color="#683153"
        />
        <stop
          offset="1"
          stop-color="#693354"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint28_linear_13_481"
        x1="47.9994"
        y1="57.1877"
        x2="47.9994"
        y2="65.863"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D38773" />
        <stop
          offset="1"
          stop-color="#D17A55"
        />
      </linearGradient>
      <linearGradient
        id="paint29_linear_13_481"
        x1="57.7518"
        y1="61.4997"
        x2="57.018"
        y2="61.4997"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DE987D" />
        <stop
          offset="1"
          stop-color="#DE987D"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint30_linear_13_481"
        x1="50.4101"
        y1="65.863"
        x2="50.4101"
        y2="65.3162"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DE987D" />
        <stop
          offset="1"
          stop-color="#DE987D"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint31_radial_13_481"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(54.8273 66.5304) rotate(-35.8376) scale(2.76517 0.940888)"
      >
        <stop stop-color="#DE987D" />
        <stop
          offset="1"
          stop-color="#DE987D"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint32_radial_13_481"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(56.3217 66.0012) rotate(-58.344) scale(2.72494 0.927197)"
      >
        <stop stop-color="#DE987D" />
        <stop
          offset="1"
          stop-color="#DE987D"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint33_linear_13_481"
        x1="38.2471"
        y1="59.7904"
        x2="38.9949"
        y2="59.7904"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CC685C" />
        <stop
          offset="1"
          stop-color="#CC685C"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint34_radial_13_481"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(39.3728 65.863) rotate(-54.589) scale(1.44958 28.981)"
      >
        <stop stop-color="#CC685C" />
        <stop
          offset="1"
          stop-color="#CC685C"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint35_linear_13_481"
        x1="47.9994"
        y1="56.3439"
        x2="47.9994"
        y2="57.8908"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.333334"
          stop-color="#6D311A"
        />
        <stop
          offset="1"
          stop-color="#C46E44"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint36_linear_13_481"
        x1="47.9994"
        y1="51.1458"
        x2="47.9994"
        y2="68.9823"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.711695"
          stop-color="#CA624F"
          stop-opacity="0"
        />
        <stop
          offset="0.873443"
          stop-color="#CA624F"
        />
      </linearGradient>
      <linearGradient
        id="paint37_linear_13_481"
        x1="47.9995"
        y1="54.0272"
        x2="47.9995"
        y2="56.9086"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D89577" />
        <stop
          offset="1"
          stop-color="#CB7368"
        />
      </linearGradient>
      <linearGradient
        id="paint38_linear_13_481"
        x1="47.9995"
        y1="51.1458"
        x2="47.9995"
        y2="51.7727"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E2A37B" />
        <stop
          offset="1"
          stop-color="#E2A37B"
          stop-opacity="0"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
